import React from 'react';
import { MetricCountBySelection } from 'common/query-builder/query-entry-section/row-types/new-metric-entry/common/metric-count-by-menu';
import { CustomizeBuckets } from 'common/query-builder/query-entry-section/row-types/new-metric-entry/common/customize-buckets';
import type { RowProps } from '../catalog';
export function SimpleMetricMeasurement(props: RowProps) {
  return <>
      <MetricCountBySelection {...props} data-sentry-element="MetricCountBySelection" data-sentry-source-file="measurement.tsx" />

      {/* buckets settings for distribution metrics */}
      <CustomizeBuckets {...props} isOpen={props.activeMenu === "customizeBuckets"} toggleOpen={() => {
      var _props$setActiveMenu;
      return (_props$setActiveMenu = props.setActiveMenu) === null || _props$setActiveMenu === void 0 ? void 0 : _props$setActiveMenu.call(props, props.activeMenu === "customizeBuckets" ? null : "customizeBuckets");
    }} data-sentry-element="CustomizeBuckets" data-sentry-source-file="measurement.tsx" />
    </>;
}